import drButton from './dr-button/dr-button'
import drSimpleLayout from './dr-simple-layout/dr-simple-layout'
import drGridLayout from './dr-grid-layout/dr-grid-layout'
import drTextField from './dr-text-field/dr-text-field'
import drGridLayoutColumn from './dr-grid-layout/dr-grid-layout-column'
import drGridLayoutRow from './dr-grid-layout/dr-grid-layout-row'
import drImage from './dr-image/dr-image'
import drText from './dr-text/dr-text'
import drDropDown from './dr-drop-down/dr-drop-down'
import drСheckbox from './dr-checkbox/dr-checkbox'
import drCaptcha from './dr-captcha/dr-captcha'
import drTextArea from './dr-text-area/dr-text-area'
import drRadiobuttons from './dr-radiobuttons/dr-radiobuttons'
import drToolbar from './dr-toolbar/dr-toolbar'
import drMenu from './dr-menu/dr-menu'
import drSpacer from './dr-spacer/dr-spacer'
import drSnippet from './dr-snippet/dr-snippet'
import drSnippetEditor from './dr-snippet-editor/dr-snippet-editor'
import drNavigation from './dr-navigation/dr-navigation'
import drCardLabel from './dr-card-label/dr-card-label'
import drComboBox from './dr-combo-box/dr-combo-box'
import drContentHeader from './dr-content-header/dr-content-header'
import drContentItem from './dr-content-item/dr-content-item'
import drDateEdit from './dr-date-edit/dr-date-edit'
import drTimePicker from './dr-time-picker/dr-time-picker'
import drFileInput from './dr-file-input/dr-file-input'
import drGrid from './dr-grid/dr-grid'
import drIcon from './dr-icon/dr-icon'
import drWidgetList from './dr-widget-list/dr-widget-list'
import itChart from './it-chart/it-chart'
import drStepper from './dr-stepper/dr-stepper'
import drLogin from './dr-login/dr-login'
import drLauncher from './dr-launcher/dr-launcher'
import drSignaturePad from './dr-signature-pad/dr-signature-pad'
import drChartCanvas from './dr-chart-canvas/dr-chart-canvas'
import drHtml from './dr-html/dr-html'
import drIframe from './dr-iframe/dr-iframe'
import drTabs from './dr-tabs/dr-tabs'
import drTab from './dr-tabs/dr-tab'
import drEds from './dr-eds/dr-eds'
import drAutocompleteElem from './dr-autocomplete-elem/dr-autocomplete-elem'
import drExpansionPanel from './dr-expansion-panel/dr-expansion-panel'
import drExpansionPanelItem from './dr-expansion-panel/dr-expansion-panel-item'
import drRating from './dr-rating/dr-rating'
import drCalendar from './dr-calendar/dr-calendar'
import drListView from './dr-list-view/dr-list-view'
import drDataWidget from './dr-data-widget/dr-data-widget'
import drPage from './dr-page/dr-page'
import drLayoutPlaceholder from './dr-layout-placeholder/dr-layout-placeholder'
import drFormio from './dr-formio/dr-formio'
import drProcess from './dr-process/dr-process-item'
import drWrapper from './dr-wrapper/dr-wrapper.vue'
import drFilter from './dr-filter/dr-filter'
import drDevexpressReporting from './dr-devexpress-reporting/dr-devexpress-reporting'
import drFileViewer from './dr-file-viewer/dr-file-viewer'

// import localization
import en from './langs/en.json'
import ru from './langs/ru.json'
import uk from './langs/uk.json'

export const componentsModels = []

const widgets = [
  drButton,
  drTextField,
  drSimpleLayout,
  drGridLayout,
  drText,
  drImage,
  drTextArea,
  drСheckbox,
  drRadiobuttons,
  drDropDown,
  drGridLayoutColumn,
  drGridLayoutRow,
  drSnippet,
  drSnippetEditor,
  drToolbar,
  drMenu,
  drSpacer,
  drNavigation,
  drCardLabel,
  drComboBox,
  drContentHeader,
  drContentItem,
  drDateEdit,
  drTimePicker,
  drFileInput,
  drGrid,
  drIcon,
  drWidgetList,
  itChart,
  drStepper,
  drLogin,
  drLauncher,
  drSignaturePad,
  drChartCanvas,
  drHtml,
  drIframe,
  drTabs,
  drTab,
  drAutocompleteElem,
  drCaptcha,
  drEds,
  drExpansionPanel,
  drExpansionPanelItem,
  drRating,
  drCalendar,
  drListView,
  drFormio,
  drProcess,
  drDataWidget,
  drPage,
  drLayoutPlaceholder,
  drFilter,
  drDevexpressReporting,
  drFileViewer
]

export const defineLocalization = function (i18n) {
  i18n.mergeLocaleMessage('en', en)
  i18n.mergeLocaleMessage('ru', ru)
  i18n.mergeLocaleMessage('uk', uk)
}

export function defineWidgets(Vue) {
  Vue.component('dr-wrapper', drWrapper)

  for (const widget of widgets) {
    Vue.component(widget.schema.$Type, widget.component)
    componentsModels.push(widget.schema)
  }
}
